import React, { useState, useEffect } from "react";
import { Android12Switch, StyledButton, StyledBox, StyledTypo, StyledPaper, StyledCarousel, StyledDialog } from "../StyledMui";
import { Grid, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, FormControlLabel, Chip, Card, CardContent, CardMedia, Button, Typography, Avatar, Stack, Box, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import useStore from "../Store";
import Cards from "./Cards";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";

function Preview(props) {
  const { isVar, setIsVar, variabledContent, setVariabledContent, variabledContents, setVariabledContents, open, setOpen, page, setPage, variableSwitchFlag, setVariableSwitchFlag, phoneMessageSwitchFlag, setPhoneMessageSwitchFlag } = useStore((state) => state.preview);
  const { templates, selectedTemplate, setSelectedTemplate, selectedChannelName, journeyType } = useStore((state) => state.header);
  const { contacts, getContacts, datas } = useStore((state) => state.mapper);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [carouselHeaderContents, setCarouselHeaderContents] = useState([]);
  const [carouselContents, setCarouselContents] = useState([]);
  const [itemListContents, setItemListContents] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);

  const { actId, queryMappingTable } = useStore(state => state.mapper)
  const { setSelectedChannelName } = useStore(state => state.header)

  useEffect(() => {
    if (!actId) return;
    (async () => {
      // 채널 이름까지 넘기도록 새로 바꾼 queryMappingTable 사용
      const rows = await queryMappingTable(actId, selectedChannelName);
      if (rows.length > 0 && rows[0].mapping) {
        const items = JSON.parse(rows[0].mapping);
        items.forEach(item => {
          if (item.name === "selectedChannelName") {
            setSelectedChannelName(item.value);
          }
          if (item.name === "selectedTemplate") {
            const tmpl = templates.find(t => t.msg_no == item.value);
            if (tmpl) setSelectedTemplate(tmpl);
          }
        });
      }
    })();
  }, [actId, selectedChannelName, queryMappingTable, setSelectedChannelName, setSelectedTemplate, templates]);

  useEffect(() => {
    console.log('Preview.js - datas:', datas);
  }, [datas]);

  useEffect(() => {
    console.log("change contacts : ", isVar);
    /**if (isVar === true) setVariabledContents(contacts.map((contact) => setVariables(contact, false))){
      if(selectedTemplate.templateMessageType === 'FC'){
        setCarouselHeaderContents(contacts.map((contact) => setVariables(contact)))
        setCarouselContents(contacts.map((contact) => setVariables(contact)))
      }else if(selectedTemplate.templateMessageType === 'FL') {
        setItemListContents(contacts.map((contact) => setVariables(contact)))
      }else{
        setVariabledContents(contacts.map((contact) => setVariables(contact)))
      }
       */

    //}
  }, [contacts]);

  useEffect(() => {
    //setVariabledContent(variabledContents[page]);
  }, [page]);

  const handleVariableSwitchFlag = (event) => {
    setVariableSwitchFlag(event.target.checked);
    if (event.target.checked === true) setPhoneMessageSwitchFlag(false);
    handleVariabled(event.target.checked, false);
  };

  const handlePhoneMessageSwitchFlag = (event) => {
    setPhoneMessageSwitchFlag(event.target.checked);
    if (event.target.checked === true) setVariableSwitchFlag(false);
    handleVariabled(event.target.checked, true);
  };

  const handleVariabled = async (sw, isPhoneMessage) => {
    console.log("handleVariabled", sw);
    console.log("contacts", contacts);

    setIsVar(sw);
    if (sw === true) {
      if (contacts.length === 0) {
        await getContacts();
      } else {
        setPage(0);
        //setVariabledContents(contacts.map((contact) => setVariables(contact, isPhoneMessage)));
      }
    }
    //setOpen(false);
  };

  const setVariables = (contact, isPhoneMessage, text) => {
    let result =
      isPhoneMessage === true
        ? JSON.parse(selectedTemplate.mmsAttach)?.mmsContent || ""
        : /*selectedTemplate.templateMessageType === 'FL' ? [1,2,3,4].map(el => {'header' : selectedTemplate[`carouselHeader${c}`, 'message' : selectedTemplate[`carouselHeader${c}`}]) :
    selectedTemplate.templateMessageType === 'FC'? [1,2,3,4,5,6].map(el => {'header' : selectedTemplate[`carouselHeader${c}`, 'message' : selectedTemplate[`carouselHeader${c}`}]):
    : selectedTemplate.templateContent*/ text;
    //console.log('setVariables!! ',datas)
    if (contact) {
      text.match(/(?<=#\{)(.*?)(?=\})/g)?.map((v) => {
        datas
          .filter((d) => d.name === v)
          .map((el) => {
            //console.log(el, contact)
            let val = el.value.toLowerCase(),
              str = el.type === "field" ? (el.value === "Contact Name" ? contact["contact last name"] + contact["contact first name"] : el.value === "SalesRep Name" ? contact["salesrep last name"] + contact["salesrep first name"] : el.value === "Name" ? contact["last name"] + contact["first name"] : contact[val]) : el.value;
            result = result.replaceAll(`#{${el.name}}`, `#{${str}}`);
          });
      });
    }
    //console.log(result)
    return result;
  };

  const handleDialogOpen = () => {
    console.log("handleDialogOpen");
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    console.log("handleDialogClose");
    setDialogOpen(false);
  };

  const handlePage = (val) => {
    let num = page;
    val === true ? num++ : num--;
    if (num < 0) num = 0;
    if (num == contacts.length) num = contacts.length - 1;
    setPage(num);
  };

  const handleRow = (index) => {
    //console.log(index)
    setPage(index);
    handleDialogClose();
  };

  const useHighlightedContent = (content, variabled) => {
    const regex = /(#{.*?})/g;
    const parts = content?.split(regex);
    //console.log(parts)
    const parsedContent = parts?.map((part, index) => {
      if (part.startsWith("#{") && part.endsWith("}")) {
        return (
          <span style={{ backgroundColor: "yellow" }} key={index}>
            {variabled === true ? part.replace(/[#\\{\\}]/gi, "") : part}
          </span>
        );
      } else {
        return part;
      }
    });

    return parsedContent;
  };
  //const highlightedContent = useHighlightedContent(selectedTemplate.templateContent);

  return (
    <>
      <StyledPaper style={{ height: "100%" }}>
        {/* <StyledBox> */}

          {/* <StyledTypo>미리보기</StyledTypo>
          {
          <Stack direction="row" spacing={2}>
            {journeyType === "segment" && <FormControlLabel control={<Android12Switch checked={phoneMessageSwitchFlag} onChange={handlePhoneMessageSwitchFlag} />} labelPlacement="start" label="문자메세지 미리보기" />}
            {journeyType === "segment" && <FormControlLabel control={<Android12Switch checked={variableSwitchFlag} onChange={handleVariableSwitchFlag} />} labelPlacement="start" label="변수적용" />}
          </Stack>
          } */}

        {/* </StyledBox> */}

        <Stack direction="row" spacing={2} alignItems="center" sx={{ paddingBottom: "10px" }}>
          <Avatar sx={{ bgcolor: "#c00032", borderRadius: "8px" }}>NN</Avatar>
          <Typography align="center" variant="subtitle1" color="text.secondary">
            {selectedChannelName}
          </Typography>
        </Stack>

        {
        // (variableSwitchFlag === true || phoneMessageSwitchFlag === true) && (
        //   <Box sx={{ display: "flex", flexDirection: "row", alignItems: "left", marginLeft: "50px", marginRight: "50px" }}>
        //     <Button color="success" variant="text" startIcon={<NavigateBeforeIcon />} onClick={() => handlePage(false)}></Button>
        //     {/* TODO: 미리보기 데이터 선택하기 라벨은 데이터 선택시 Contact Key + Name 으로 라벨 변경 */}
        //     <Button onClick={handleDialogOpen} color="success" variant="text" startIcon={<PersonSearchIcon />}>
        //       미리보기 데이터 선택하기
        //     </Button>
        //     <Button color="success" variant="text" endIcon={<NavigateNextIcon />} onClick={() => handlePage(true)}></Button>
        //   </Box>
        // )
        }

        {
        // (
        //   <Box sx={{ display: "flex", flexDirection: "row", alignItems: "left", marginLeft: "50px", marginRight: "50px" }}>
        //     <Button color="success" variant="text" startIcon={<NavigateBeforeIcon />} onClick={() => handlePage(false)}></Button>
        //     {/* TODO: 미리보기 데이터 선택하기 라벨은 데이터 선택시 Contact Key + Name 으로 라벨 변경 */}
        //     <Button onClick={handleDialogOpen} color="success" variant="text" startIcon={<PersonSearchIcon />}>
        //       미리보기 데이터 선택하기
        //     </Button>
        //     <Button color="success" variant="text" endIcon={<NavigateNextIcon />} onClick={() => handlePage(true)}></Button>
        //   </Box>
        // )
        }
        <Cards />
      </StyledPaper>

      <StyledDialog open={isDialogOpen} onClose={handleDialogClose}>
        <DialogTitle>미리보기 데이터 선택 다이얼로그</DialogTitle>
        <DialogContent>
          <StyledBox component="div">
            <StyledTypo>Entry Source Data</StyledTypo>
          </StyledBox>
          <Table size="small">
            <TableHead>
              <TableRow>{contacts.length > 0 ? Object.keys(contacts[0]).map((key) => <TableCell>{key}</TableCell>) : ""}</TableRow>
            </TableHead>
            <TableBody>
              {contacts?.map((contact, index) => (
                <TableRow key={index} onMouseEnter={() => setSelectedRow(index)} onMouseLeave={() => setSelectedRow(null)} style={selectedRow === index ? { backgroundColor: "#e0e0e0" } : {}}>
                  {Object.values(contact).map((value) => (
                    <TableCell sx={{ "&:hover": { cursor: "pointer" } }} onClick={() => handleRow(index)}>
                      {value}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>닫기</Button>
        </DialogActions>
      </StyledDialog>
    </>
  );
}

export default Preview;
